
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ServicesDropdown } from "./ServicesDropdown";
import { WindowTypesDropdown } from "./WindowTypesDropdown";
import { BenefitsDropdown } from "./BenefitsDropdown";

export const DesktopNavigation = () => {
  return (
    <div className="hidden md:flex items-center space-x-2">
      <Link to="/" className="font-inter text-secondary-dark hover:text-primary transition-colors">
        Home
      </Link>
      
      <ServicesDropdown />
      <WindowTypesDropdown />
      <BenefitsDropdown />
      
      <Link to="/blog-secondary-glazing" className="font-inter text-secondary-dark hover:text-primary transition-colors">
        Blog
      </Link>
      <Link to="/free-resources" className="font-inter text-secondary-dark hover:text-primary transition-colors">
        Free Guides
      </Link>
      <Link to="/contact" className="font-inter text-secondary-dark hover:text-primary transition-colors">
        Contact
      </Link>
      <Link to="/get-quote">
        <Button className="bg-primary hover:bg-primary-light text-white">Get Quote</Button>
      </Link>
    </div>
  );
};
